import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ModalForm from "../general/ModalForm";
import Loading from "../general/Loading";

function ParametrosFacturacion() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    const [resolucion, setResolucion] = useState();
    const [prefijo, setPrefijo] = useState();
    const [numeroFactura, setNumeroFactura] = useState();
    const [numeracionDesde, setNumeracionDesde] = useState();
    const [numeracionHasta, setNumeracionHasta] = useState();
    const [responsableIva, setResponsableIva] = useState();
    const [activar, setActivar] = useState();
    const [parametrosId, setParametrosId] = useState();

    const [errorlist, setErrorlist] = useState({});
    
    const [parametrosExisten, setParametrosExisten] = useState(false);

    let history = useHistory();

    let userdata = [];
    let clientData = [];
    let rolePermissions = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });

        axios.get('parametros-facturacion?uid='+userdata.user_id,config)
            .then(response => {
                console.log(response.data);
                if (response.data) {
                    setParametrosExisten(true);
                    
                    setParametrosId(response.data.id);
                    setResolucion(response.data.resolucion);
                    setPrefijo(response.data.prefijo);
                    setNumeroFactura(response.data.numero_factura);
                    setNumeracionDesde(response.data.numeracion_desde);
                    setNumeracionHasta(response.data.numeracion_hasta);
                    setResponsableIva(response.data.responsable_iva);
                    setActivar(response.data.activar);
                }
            })
            .catch(error => console.log(error.response.data))
        
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            resolucion: resolucion,
            prefijo: prefijo,
            numero_factura: numeroFactura,
            numeracion_desde: numeracionDesde,
            numeracion_hasta: numeracionHasta,
            responsable_iva: responsableIva,
            activar: activar
        };
        
        console.log(conf);
        if (parametrosExisten) {
            conf.id = parametrosId;
            axios.put('/parametros-facturacion', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los parámetros de factura electrónica han sido modificados');
                        history.push('/parametros-sistema');
                    }
                )
                .catch(
                    err => {
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        else {
            axios.post('/parametros-facturacion', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los parámetros de factura electrónica han sido creados');
                        history.push('/parametros-sistema');
                    }
                )
                .catch(
                    err => {
                        console.log(err.response.data);
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Parametrizar Facturación Electrónica</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Parametrizar Facturación Electrónica</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-10">
                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="form-group">
                                                                    <label>Resolución DIAN</label>
                                                                    <input type="text" name="resolucion" className="form-control" id="resolucion" value={resolucion} onChange={(e) => setResolucion(e.target.value)} autoFocus />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.resolucion}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className="form-group">
                                                                    <label>Prefijo</label>
                                                                    <input type="text" name="prefijo" className="form-control" id="prefijo" value={prefijo} onChange={(e) => setPrefijo(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.prefijo}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className="form-group">
                                                                    <label>Número factura</label>
                                                                    <input type="text" name="numero_factura" className="form-control" id="numero_factura" value={numeroFactura} onChange={(e) => setNumeroFactura(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.numero_factura}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Numeración desde</label>
                                                                    <input type="text" name="numeracion_desde" className="form-control" id="direnumeracion_desdeccion" value={numeracionDesde} onChange={(e) => setNumeracionDesde(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.numeracion_desde}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Numeración hasta</label>
                                                                    <input type="text" name="numeracion_hasta" className="form-control" id="numeracion_hasta" value={numeracionHasta} onChange={(e) => setNumeracionHasta(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.numeracion_hasta}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Responsable IVA</label>
                                                                    <select name="responsable_iva" className="form-control" id="responsable_iva" value={responsableIva} onChange={(e) => setResponsableIva(e.target.value)}>
                                                                        <option></option>
                                                                        <option value='0'>SIN IVA</option>
                                                                        <option value='1'>CON IVA</option>
                                                                    </select>
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.responsable_iva}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Activar</label>
                                                                    <select name="activar" className="form-control" id="activar" value={activar} onChange={(e) => setActivar(e.target.value)}>
                                                                        <option></option>
                                                                        <option value='0'>NO</option>
                                                                        <option value='1'>SI</option>
                                                                    </select>
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.activar}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button type="submit" className="btn btn-primary">
                                                            Guardar&nbsp;
                                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                            
                                                        </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ParametrosFacturacion;